module.exports = __webpack_public_path__ + "static/media/teachersaid-logo.ba6c6651.png";